<template>
<div class="grid mt-4">	
<template v-if="!is_connected">
<div class="col-12 ">
<h4 class="text-red-500">Bu modüle bağlı bir veri modülü bulunmuyor</h4>
</div>	
</template>

<template v-else>

<div class="col-12" v-if="!show_add_output">
<h4 class="text-primary">Listelenecek Girdileri Seçin</h4>
</div>	

<div class="col-12 pb-5" v-if="!show_add_output">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_input" :options="inputs" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputSelected"/>
<label  class="text-primary">Bir Giriş Seçin</label>
</span>
</div>




<template v-if="show_add_output">

<div class="col-12">
<h4 class="text-primary">Yeni Sütun Alanı</h4>
</div>

<div class="col-12 pb-5" v-if="show_value_input">
<span class="p-float-label">
<InputText  type="text" v-model="new_item.value" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Hücrede Görünecek Değer</label>
</span>
</div>	


<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="new_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
</span>
</div>


<div class="col-6 flex mt-2" v-if="!show_value_input">
  <label  class="text-primary">Sıralanabilir</label>
  <InputSwitch v-model="new_item.sortable" class="ml-2"/> 
</div>
<div class="col-6 flex mt-2" v-if="!show_value_input">
  <label  class="text-primary">Filtrelenebilir</label>
  
  <InputSwitch v-model="new_item.filterable"  class="ml-2"/>
</div>


<div class="col-12">
<h4>Alan Çevirileri</h4>
</div>

<div class="col-12 pb-5" v-for="element in new_item.translations">
<span class="p-float-label">
<InputText  type="text" v-model="element.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">{{element.language.name}} için Sütun İsmi</label>
</span>
</div>

<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelNewItem"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitNewItem"></Button>
</div>
</div>

	 
</template>
















<div class="col-12 ">
<h4 class="text-primary">Listeleme Sütunları</h4>
</div>


<div class="col-12 ">
<draggable 
v-model="$store.state.calculations.selectednode.data.outputs"
class="grid" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">


<!--item column-->
<template #item="{element}">	
<div class="col-12" >

<!--item viewing-->
<div class="grid" v-if="!element.is_editing">
<div class="col-1 handle">	
<span class="material-symbols-outlined">
drag_handle
</span>

</div>
<div class="col-9"><small>{{element.name}}</small></div>
<div class="col-2">
<Button type="button"  icon="pi pi-pencil" @click="editItem(element.id)" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
<Button type="button"  icon="pi pi-times" @click="deleteItem(element.id)" class="p-button-danger p-button-outlined p-button-sm "  />
</div>
</div>
<!--item viewing-->

<!--item editing-->
<div class="grid raised_item pt-6" v-if="element.is_editing && editing_item">


<div class="col-12 pb-5" v-if="editing_item.type=='value'">
<span class="p-float-label">
<InputText  type="text" v-model="editing_item.value" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Hücrede Görünecek Değer</label>
</span>
</div>	

<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="editing_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
<small class="text-pink-500 mt-3" v-if="editing_item.source_name">Orijinal Alan: <span class="font-bold">{{editing_item.source_name}}</span></small>
</span>
</div>

<div class="col-6 flex mt-2" v-if="editing_item.type!=='value'">
  <label  class="text-primary">Sıralanabilir</label>
  <InputSwitch v-model="editing_item.sortable" class="ml-2"/> 
</div>
<div class="col-6 flex mt-2" v-if="editing_item.type!=='value'">
  <label  class="text-primary">Filtrelenebilir</label>
  
  <InputSwitch v-model="editing_item.filterable"  class="ml-2"/>
</div>



<div class="col-12">
<h4>Alan Çevirileri</h4>
</div>


<div class="col-12 pb-5" v-for="item in editing_item.translations">
<span class="p-float-label">
<InputText  type="text" v-model="item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">{{item.language.name}} için Sütun İsmi</label>
</span>
</div>

<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelEditItem(editing_item.id)"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitChanges(editing_item.id)"></Button>
</div>
</div>



</div>

<!--item editing-->
</div>
</template>
<!--item column-->

</draggable>
</div>

	
</template>


</div>	
</template>

<script>
export default {

  name: 'ListNodeData',

  data () {
    return {
    	selected_input:null,
    	inputs:[
    	{name:"Text",id:0,type:"value",is_editing:false,sortable:1,filterable:1}
    	],
    	show_value_input:false,
    	show_add_output:false,
    	thevalue:null,
    	languages:[],
    	new_item:null,
    	editing_item:null,

    }
  },
  computed:{
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  	is_connected()
  	{
  		console.log("is_connected")
  		this.getLanguages()
  		if(this.$store.state.calculations.selectednode)
  		{
  			let selectednode = this.$store.state.calculations.selectednode
  			
  			let connections = this.$store.state.calculations.connections
  			let the_connection = connections.findIndex((item)=>{return item.to == selectednode.id})
  			if(the_connection!==-1)
  			{
  				let root_node = this.findRootNode()
  				return true
  			}
  			return false
  		}
  		return false  		
  	},
  },
  methods:{
  	end(event)
    { 
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      console.log(event)      
    },
  	editItem(id)
  	{
  		this.setAllOutputNonEditing()
  		let selectednode = this.$store.state.calculations.selectednode
  		console.log(selectednode.data)
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		this.editing_item =  selectednode.data.outputs[selected_item_ind]
      let source_node = this.inputs.find(item=>item.stack_id == this.editing_item.input_stack_id)
      if(source_node)
      {
        this.editing_item.source_name = source_node.name
      }
      else
      {
        this.editing_item.source_name = null
      }
  		selectednode.data.outputs[selected_item_ind].is_editing = true
  		this.updateNodeData(selectednode)
  	},

  	async deleteItem(id)
  	{
  		console.log(id)
      //return false
  		let formdata = new FormData()
      this.generalSubmission(formdata,"delete_node_column/"+id,this.afterDelete)
  		
  	},
  	afterDelete(response)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.outputs =  selectednode.data.outputs.filter((item)=>{return item.id !== response.data})
  		this.updateNodeData(selectednode)
  	},
  	cancelEditItem(id)
  	{
  		this.setAllOutputNonEditing()
  		let selectednode = this.$store.state.calculations.selectednode
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		selectednode.data.outputs[selected_item_ind].is_editing = false
  		this.updateNodeData(selectednode) 
  	},
  	submitChanges(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		selectednode.data.outputs[selected_item_ind] = this.editing_item
  		selectednode.data.outputs[selected_item_ind].is_editing = false
  		this.updateNodeData(selectednode)
  		this.setAllOutputNonEditing()
  	},
  	setAllOutputNonEditing()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		for(let output of selectednode.data.outputs)
  		{
  			output.is_editing = false
  		}
  		this.updateNodeData(selectednode)
  	},

  	async getLanguages()
  	{
  		this.languages = await this.generalApiGetWithoutLoader("languages")
  		console.log("languages")
  	},
  	submitValue()
  	{
  		let obj = {
  			name:this.thevalue+ " - Değer",
  			type:"value",
  			id:Math.floor(Date.now() / 10),
  			value:this.thevalue
  		}
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.output.inputs.push(obj)
  		this.updateNodeData(selectednode)
  		this.selected_input = null
  	},
  	cancelValue()
  	{
  		this.show_value_input = false
  		this.thevalue = 0
  		this.selected_input = null
  	},
  	inputSelected()
  	{
  		let type
  		if(this.selected_input.type=="value")
  		{
  			type = "value"
  			this.show_value_input = true
  		}
  		else
  		{
  			type = "input"
  			this.show_value_input = false
  		}
  		this.new_item = {
  			name:this.selected_input.name,
  			input_stack_id:this.selected_input.stack_id,
  			id:Math.floor(Date.now() / 10),
  			translations:[],
  			value:null,
  			type:type,
  			is_editing:false,
        sortable:true,
        filterable:true
  		}
  		for(let language of this.languages)
  		{
  			let lang_obj = {
  				name:this.selected_input.name,
  				language:language,  				
  			}
  			this.new_item.translations.push(lang_obj)
  		}
  		setTimeout(()=>{
  			this.show_add_output = true
  		},10)
  		
  		
  		
  	},
  	cancelNewItem()
  	{
  		this.show_add_output = false
  		this.show_value_input = false
  		this.selected_input = null
  	},
  	submitNewItem()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		console.log(selectednode)
  		//return false
  		selectednode.data.outputs.push(this.new_item)
  		this.updateNodeData(selectednode)
  		setTimeout(()=>{
  			this.cancelNewItem()
  		},10)
  	},

  	updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      	this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},
  	findRootNode()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let the_connection = connections.find((item)=>{return item.to == selectednode.id.toString()}) 
  		if(the_connection)
  		{  			
  			let from_node = this.findPrevNode(the_connection.from)  			
  			return from_node
  		}
  		return "no_connection"
  	},
  	findPrevNode(nodeId)
  	{
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let node = nodes.find((item)=>{return item.id == nodeId.toString()})
  		console.log("findPrevNode")
  		console.log(node)
  		if(node.key=="calculations")
      {         
        let calculation_item = {
              stack_id:node.id,
              name:node.title,
              type:"calculation",
          }
          this.addToInputsStack(calculation_item)
      }
      if(node.type=="conditional_logic")
      {         
        let calculation_item = {
              stack_id:node.id,
              name:node.title,
              type:"conditional_logic",
          }
          this.addToInputsStack(calculation_item)
      }
  		//if prev node is not suppliers
  		if(node.type!=="suppliers")
  		{
  			let the_connection = connections.find((item)=>{return item.to == nodeId.toString()})
  			if(!the_connection)
  			{
  				return "no_connection"
  			}
  			let from_node = this.findPrevNode(the_connection.from) 
  			
  			
  			return from_node
  		}
  		//if prev node is not suppliers

  		//if prev node is suppliers
  		node = this.sanitizeArray(node)
  		let outputs = node.data.outputs
  		console.log("OUTPUTS")
      console.log(outputs)
  		for(let item of outputs)
  		{				
  			this.addToInputsStack(item)
  		}
  		return node
  		//if prev node is suppliers

  	},
  	addToInputsStack(input)
  	{
  		
  		this.inputs.push(input)
  	},
  },
}
</script>

<style lang="css" scoped>
	.handle{
		cursor: pointer;
	}
</style>